<template>
  <div
    id="donorProjects"
    ref="mainDiv"
    @scroll="onScroll"
    class="wrapperProjectsMainDonor"
  >
    <div class="projects-container">
      <div>
        <projectsStatsHeader
          :countryName="donor.name"
          :peopleImpacted="population"
          :projectsCompleted="projectsNb"
          :completed="true"
        />
      </div>
      <section v-if="currentProjects.length > 0" class="projects-wrapper">
        <div
          v-for="(project, index) in currentProjects"
          :key="project.id + 1"
          :id="'project' + index"
          class="project"
        >
          <project-header
            :project="project"
            :showAnalytics="true"
            :has_many="true"
            :completed="true"
            :changePopUpStyle="true"
          />
          <project-carousel
            v-if="project.pictures?.length > 0"
            :pictures="project.pictures"
            :stages="stages"
            :completed="true"
            :projectIndex="index"
            :ref="`carousel${index}`"
            :has_many="false"
            :inTheViewPort="carouselVisibility[index]"
          />
        </div>
        <loading v-if="loading" />
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import projectsStatsHeader from '../reusableComponents/ProjectsStatsHeader.vue'
import projectHeader from '../reusableComponents/ProjectHeader.vue'
import projectCarousel from '../reusableComponents/ProjectCarousel.vue'
import loading from '../reusableComponents/Loading.vue'
export default {
  props: {
    donor: {
      type: Object,
      required: true,
    },
    projectsNb: { type: Number, required: true },
    population: { type: Number, required: true },
  },
  components: {
    projectsStatsHeader,
    projectHeader,
    projectCarousel,
    loading,
  },
  data() {
    return {
      index: 0,
      addMore: 5,
      currentProjects: [],
      projectTypes: null,
      pictures: null,
      loading: false,
      mainFuncRunning: false,
      noMoreProjects: false,
      countries: null,
      stages: null,
      carouselVisibility: [],
    }
  },
  async created() {
    let projectsTypesFetch = await axios.post('/api/project_types', {
      index: 0,
      totalCount: 50,
      additionalColumns: ['id', 'name', 'icon', 'marker_icon'],
    })
    this.projectTypes = projectsTypesFetch.data.data

    let countriesFetch = await axios.post('/api/countries', {
      additionalColumns: ['id', 'name', 'flag_url'],
    })

    this.countries = countriesFetch.data.data

    let projectsStagesFetch = await axios.post('/api/project_stages', {
      index: 0,
      totalCount: 50,
      additionalColumns: ['id', 'name', 'picture_caption'],
    })
    this.stages = projectsStagesFetch.data.data
    this.loadProjects()
  },
  mounted() {
    let mainHeaderHeight = $('#mainHeader').innerHeight()
    $('#donorProjects').css('height', `calc(100vh - ${mainHeaderHeight}px)`)
  },
  methods: {
    async loadProjects() {
      let fetchProjects = await axios.post('/api/projects', {
        meta: true,
        index: this.index,
        totalCount: this.addMore,
        additionalColumns: [
          'id',
          'name',
          'project_stage_id',
          'country_id',
          'project_type_id',
          'latitude',
          'longitude',
          'completion_date',
          'description',
          'population',
          'position',
          'monitored',
        ],
        query: {
          project_donors_donor_id_eq: this.donor.id,
          project_stage_is_completed_eq: true,
        },
        sort: 'COALESCE(projects.position, 99999999) ASC, projects.completion_date DESC',
      })

      let idArray = fetchProjects.data.data.map((obj) => obj.id)
      let allPictures = []
      let nbPicturesToDownload = 0
      if (idArray.length > 0) {
        do {
          let getMeta = allPictures.length === 0
          let fetchPictures = await axios.post('/api/pictures', {
            meta: getMeta,
            index: allPictures.length,
            query: {
              project_id_in: idArray,
              share_with_donors_eq: true,
              s: ['cover DESC', 'project_stage_position DESC', 'id DESC'],
            },
            additionalColumns: [
              'public_id',
              'project_id',
              'project_stage_id',
              'secure_url',
              'aspect_ratio',
              'height',
              'width',
              'favorite',
            ],
          })
          nbPicturesToDownload = getMeta
            ? fetchPictures.data.meta.recordsFiltered
            : nbPicturesToDownload
          allPictures = allPictures.concat(fetchPictures.data.data)
        } while (allPictures.length < nbPicturesToDownload)
      }

      let organizeProjects = await Promise.all(
        fetchProjects.data.data.map(async (project) => {
          let x = await this.organizeData(project, allPictures)
          return x
        })
      )

      if (organizeProjects.length === 0) {
        this.noMoreProjects = true
      }

      this.currentProjects = [
        ...this.currentProjects,
        ...organizeProjects.filter(
          (project) =>
            !this.currentProjects.some(
              (currProject) => currProject.id === project.id
            )
        ),
      ]
      this.index += this.addMore
      this.loading = false
      this.mainFuncRunning = false
    },
    async organizeData(project, pictures) {
      let currentType = this.projectTypes.find(
        (projectType) => project.project_type_id === projectType.id
      )
      let currentCountry = this.countries.find(
        (country) => country.id === project.country_id
      )
      return {
        id: project.id,
        project_name: project.name,
        completion_date: project.completion_date,
        description: project.description || '',
        location: {
          lat: parseFloat(project.latitude),
          lng: parseFloat(project.longitude),
        },
        project_type: {
          name: currentType.name,
          icon: currentType.icon,
          marker_icon: currentType.marker_icon,
        },
        project_country: currentCountry,
        pictures: pictures.filter((obj) => obj.project_id === project.id),
        population: project.population,
        monitored: project.monitored,
      }
    },
    async onScroll(event) {
      this.checkCarouselVisibility()

      const projectsWrapper = event.target

      const scrollThreshold = 600

      if (
        projectsWrapper.scrollTop + projectsWrapper.clientHeight >=
        projectsWrapper.scrollHeight - scrollThreshold
      ) {
        if (this.loading === true || this.mainFuncRunning === true) {
          return
        } else {
          if (this.noMoreProjects) {
            return
          }

          this.loading = true
          await this.loadProjects()
        }
      }
    },
    checkCarouselVisibility() {
      this.currentProjects.forEach((project, index) => {
        const refName = `carousel${index}`
        const carouselContainer = this.$refs[refName]
        if (carouselContainer) {
          const navigationName = `slide${index}`
          const element = carouselContainer[0].$refs[navigationName]
          const elementRect = element.getBoundingClientRect()
          const mainDivRect = document
            .getElementById('donorProjects')
            .getBoundingClientRect()
          const isVisible =
            Math.abs(elementRect.top) >= mainDivRect.top &&
            Math.abs(elementRect.bottom) <= mainDivRect.bottom
          this.carouselVisibility[index] = isVisible
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapperProjectsMainDonor {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

.projects-container {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: auto;
  padding-top: 30px;
  height: 100%;
}

.projects-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 4rem;
}
</style>
